<mat-card [class]="'mat-bg-' + tileColor">
  <app-data-change-indicator
    class="data-change-indicator-top-right"
    [icon]="indicatorIcon"
    [iconColor]="indicatorIconColor"
    [text]="indicatorText"
    [textColor]="indicatorTextColor"
  >
  </app-data-change-indicator>
  <mat-card-content>
    <huge-row>
      <mat-col class="text-align-center" style="width: 100%;">
        <div>
          <p [class]="'data-tile-value mat-text-' + valueColor">
            {{ value }}
          </p>
        </div>
        <div>
          <p (color)="(titleColor)" [class]="'data-tile-title mat-text-' + titleColor" [ngClass]="{ 'data-title-shrink': title.length > 20 }">
            {{ title }}
          </p>
        </div>
        <div>
          <p (color)="(subTitleColor)" [class]="'data-tile-sub-title mat-text-' + subTitleColor">
            {{ subTitle }}
          </p>
        </div>
      </mat-col>
    </huge-row>
  </mat-card-content>
</mat-card>
